import React, { useEffect, FC, useState } from "react";
import { Modal, ModalBody, Form, Row, Col, Alert } from "reactstrap";
import { Icon, Button, RSelect } from "../../../components/Component";
import { FormProvider, useForm } from "react-hook-form";
import rolesApi from "../../../api/master/roles";
import Swal from "sweetalert2";
import FormInput from "../../form-components/InputComponent";
import FormSelect from "../../form-components/SelectComponent";
import FormTextArea from "../../form-components/TextAreaComponent";
import FormMultiSelect from "../../form-components/MultiSelectComponent";

interface SelectOptions {
  label: string;
  value: string;
}

const AddModal: FC<any> = ({
  modal,
  closeModal,
  onSubmit,
  formData,
  setFormData,
  filterStatus,
  alertInfo,
  hasSequence,
}) => {
  useEffect(() => {
    reset(formData);
  }, [formData]);
  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    formState: { errors },
    setValue,
    trigger,
    watch,
    reset,
  } = methods;
  const [roles, setRoles] = useState<SelectOptions[]>([]);
  const fetchRoles = async () => {
    try {
      const { data, status, message } = await rolesApi.fetchRolesData();
      if (status) {
        if (data.length > 0) {
          const transformedData = data.map((obj: any) => ({
            label: obj.roleName,
            value: obj.roleID,
          }));
          setRoles(transformedData);
        }
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (err: any) {
      Swal.fire("Error", err.response?.data?.message || err.message, "error");
    }
  };
  useEffect(() => {
    fetchRoles();
  }, []);
  return (
    <Modal
      isOpen={modal}
      toggle={() => closeModal()}
      className="modal-dialog-centered"
      size="xl"
      backdrop="static"
    >
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            closeModal();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="p-2">
          <h5 className="title">Add General Ledger</h5>
          {alertInfo.message && (
            <div className="mb-3 mt-1">
              <Alert
                color={alertInfo.type === "error" ? "danger" : "success"}
                className="alert-icon"
              >
                <strong>{alertInfo.message}</strong>
                <Icon
                  name={
                    alertInfo.type === "error" ? "alert-circle" : "check-circle"
                  }
                />
                {alertInfo.errors.length > 0 ? (
                  <ul>
                    {alertInfo.errors.map((err: any, index: any) => (
                      <li key={index}>{err}</li>
                    ))}
                  </ul>
                ) : (
                  ""
                )}
              </Alert>
            </div>
          )}
          <div className="mt-4">
            <FormProvider {...methods}>
              <Form
                className="row gy-4"
                noValidate
                onSubmit={handleSubmit(onSubmit)}
              >
                {!hasSequence && (
                  <Col md="4">
                    <FormInput
                      name="referenceID"
                      label="Ledger ID"
                      type="text"
                      pattern={/^[a-zA-Z0-9./_-]+$/}
                      required={true}
                      maxLength={20}
                      placeholder="Enter Ledger ID"
                    />
                  </Col>
                )}
                <Col md="4">
                  <FormInput
                    required={true}
                    name="ledgerName"
                    label="Ledger Name"
                    type="text"
                    pattern={/^[a-zA-Z\s]*$/}
                    maxLength={100}
                    placeholder="Enter Ledger Name"
                  />
                </Col>
                <Col md="4">
                  <FormMultiSelect
                    name="roles"
                    label="Select Role"
                    options={roles}
                    placeholder="-Select-"
                  />
                </Col>
                <Col md="12">
                  <div className="form-group">
                    <FormTextArea
                      name="description"
                      label="Description"
                      placeholder="Write your description"
                      minLength={5}
                      maxLength={200}
                    />
                  </div>
                </Col>
                <Row className="mt-4">
                  <Col md="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button
                          className="btn btn-primary btn-md"
                          type="submit"
                          color="primary"
                        >
                          {/* <Icon name="check" /> */}
                          <span>Submit</span>
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            closeModal();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </Form>
            </FormProvider>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default AddModal;
